export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/branding_services.4726bbe.svg";